import React from "react";
import { useParams } from "react-router-dom";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: `Koshsam Taxi ("we", "us") respects your privacy. This policy explains what personal data we collect when you use samtaxi.online and how we use it.\n\nWe collect: name, email, phone, pickup/destination addresses and payment metadata. We never store full card details — payments are processed by Mollie (PCI-DSS compliant).\n\nWe use your data to fulfil bookings, send confirmations, and comply with Dutch tax law. We retain booking data for 7 years per Belastingdienst requirements.\n\nYou have the right to access, correct, or delete your personal data. Contact info@samtaxi.online.`,
  },
  terms: {
    title: "Terms & Conditions",
    body: `By booking with Sam Taxi you agree to these terms.\n\n1. Pricing is fixed at the moment of booking. Waiting time exceeding 15 minutes at pickup is charged at €0.50/min.\n\n2. Cancellations must be made at least 2 hours before pickup for a full refund. Paid bookings cancelled after this window are non-refundable.\n\n3. We are not liable for delays caused by force majeure (weather, traffic, government action).\n\n4. Maximum 4 passengers per sedan and 6 per minivan. Children under 12 require a child seat (free upon request).\n\n5. Disputes are governed by Dutch law and submitted to the courts of Amsterdam.`,
  },
  cookies: {
    title: "Cookie Policy",
    body: `We use only essential cookies needed to keep you logged in and remember your language preference. We do not use advertising or tracking cookies. You can clear cookies at any time via your browser settings.`,
  },
};

export default function Legal() {
  const { slug } = useParams();
  const c = CONTENT[slug] || CONTENT.privacy;
  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-10 py-20 text-white">
      <div className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Legal</div>
      <h1 className="font-heading text-5xl mb-8">{c.title}</h1>
      <div className="prose prose-invert max-w-none">
        {c.body.split("\n\n").map((p, i) => (
          <p key={i} className="text-white/75 leading-relaxed mb-4">{p}</p>
        ))}
      </div>
    </div>
  );
}
